import { render, staticRenderFns } from "./BotaoInteligencia.vue?vue&type=template&id=ed0043c6&lang=pug"
import script from "./BotaoInteligencia.vue?vue&type=script&lang=js"
export * from "./BotaoInteligencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports